import {Injectable} from '@angular/core';
import {HttpService} from '../../common/api/http.service';

@Injectable()
export class ProgramManagementApi {
    private readonly prefix = 'program-management';

    constructor(private api: HttpService) {}
}
